import { Elements, PaymentElement } from "@stripe/react-stripe-js"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { fetchStripeCSCSecretQuery, fetchStripeObjectQuery } from "../queries"
import { Frequency, Total } from "../types"

// TODO: Replace with min/max obtained from donation form config
const STRIPE_PAYMENT_ELEMENT_MINIMUM_AMOUNT_CENTS = 50
const STRIPE_PAYMENT_ELEMENT_MAXIMUM_AMOUNT_CENTS = 99999999

const brandColor = getComputedStyle(document.body)
  .getPropertyValue("--color-brand")
  .trim()

type StripePaymentElementProps = {
  amountCents: Total
  frequency: Frequency
}

export function StripePaymentElement({
  amountCents,
  frequency,
}: StripePaymentElementProps) {
  const { config } = useDonationFormContext()

  const { data: stripeObject } = useSuspenseQuery(
    fetchStripeObjectQuery(config),
  )

  const { data: stripeCustomerSessionClientSecret } = useSuspenseQuery(
    fetchStripeCSCSecretQuery(),
  )

  // TODO: Obtain this via some kind of validation/util function
  const validAmount =
    amountCents >= STRIPE_PAYMENT_ELEMENT_MINIMUM_AMOUNT_CENTS &&
    amountCents <= STRIPE_PAYMENT_ELEMENT_MAXIMUM_AMOUNT_CENTS

  if (stripeObject && stripeCustomerSessionClientSecret) {
    return (
      <Elements
        stripe={stripeObject}
        options={{
          mode: frequency.type === "once" ? "payment" : "setup",
          amount: validAmount
            ? amountCents
            : STRIPE_PAYMENT_ELEMENT_MINIMUM_AMOUNT_CENTS,
          currency: "usd",
          customerSessionClientSecret: stripeCustomerSessionClientSecret,
          appearance: {
            variables: {
              borderRadius: "8px",
              colorPrimary: brandColor,
            },
            rules: {
              ".AccordionItem": {
                padding: "24px",
              },
            },
          },
        }}
      >
        <PaymentElement
          options={{
            layout: {
              type: "accordion",
            },
            fields: {
              billingDetails: {
                name: "auto",
                email: "never",
                phone: "auto",
                address: "auto",
              },
            },
            terms: {
              card: "never",
              usBankAccount: "never",
              auBecsDebit: "never",
            },
            wallets: {
              applePay: "auto",
              googlePay: "never",
            },
          }}
        />
      </Elements>
    )
  } else {
    return null
  }
}
